<script>
import { contentBlocksComputed } from '@state/helpers'

export default {
  props: {
    html: {
      type: String,
      default: '',
    },
    block: {
      type: String,
      default: '',
    },
    jumbotron: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...contentBlocksComputed,
    htmlToRender() {
      return this.html || this.getContentBlock(this.block)
    },
  },
  watch: {
    htmlToRender: {
      handler() {
        this.$nextTick(() => {
          const noteEls = this.$el.querySelectorAll('p > em, p > i')
          for (const noteEl of noteEls) {
            if (!noteEl.previousSibling && !noteEl.nextSibling) {
              noteEl.classList.add(this.$style.onlyChild)
            }
          }
          const checkForEmpties = () => {
            let foundEmptyEl = false
            const emptyEls = this.$el.querySelectorAll(`
              h1:empty,
              h2:empty,
              h3:empty,
              h4:empty,
              h5:empty,
              h6:empty,
              p:empty,
              div:empty,
              ul:empty,
              ol:empty,
              li:empty,
              strong:empty,
              em:empty,
              b:empty,
              i:empty,
              br
            `)
            for (const emptyEl of emptyEls) {
              foundEmptyEl = true
              emptyEl.parentNode.removeChild(emptyEl)
            }
            if (foundEmptyEl) checkForEmpties()
          }
          checkForEmpties()
        })
      },
      immediate: true,
    },
  },
}
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    :class="[$style.container, { [$style.jumbotron]: jumbotron }]"
    v-html="htmlToRender"
  />
</template>

<style lang="scss" module>
@use '@design' as *;

.container {
  > :first-child {
    margin-top: 0 !important;
  }

  > :last-child {
    margin-bottom: 0 !important;
  }

  &.jumbotron {
    img[style*='text-align: center'],
    [style*='text-align: center'] img {
      margin: 0 auto;
    }

    strong,
    em,
    b,
    i,
    a {
      display: block;
      margin-bottom: $size-grid-padding;
    }

    p,
    ul,
    ol,
    li,
    pre,
    strong {
      @include typography-got-rhythm(0);

      strong,
      em,
      b,
      i,
      a {
        display: inline;
        margin: 0;
      }

      em,
      i {
        &.onlyChild {
          @include typography-got-rhythm(-1);
        }
      }
    }
  }
}
</style>
